export const getters = {
  // Get all sessions for an organization (sorted by newest first)
  getOrgSessions: (state) => (orgId) => {
    const sessions = Object.values(state.sessions[orgId] || {})
    // Sort by created_at descending (newest first)
    return sessions.sort((a, b) => {
      const dateA = new Date(a.created_at)
      const dateB = new Date(b.created_at)
      return dateB - dateA
    })
  },

  // Get a specific session
  getSession: (state) => (orgId, sessionCode) => {
    return state.sessions[orgId]?.[sessionCode] || null
  },

  // Get active session
  getActiveSession: (state) => {
    if (!state.activeSessionCode) return null

    // Find the session in any org
    for (const orgId in state.sessions) {
      const session = state.sessions[orgId][state.activeSessionCode]
      if (session) return session
    }
    return null
  },

  // Get messages for a session
  getSessionMessages: (state) => (sessionCode) => {
    return state.messages[sessionCode] || []
  },

  // Get active session code
  getActiveSessionCode: (state) => {
    return state.activeSessionCode
  },

  // ==================== Prompt Getters ====================

  // Get prompts for a session
  getSessionPrompts: (state) => (sessionCode) => {
    return state.prompts[sessionCode] || null
  },

  // Get total count of prompts (projects + layers) for a session
  getTotalPromptsCount: (state, getters) => (sessionCode) => {
    const prompts = getters.getSessionPrompts(sessionCode)
    if (!prompts) return 0
    return (prompts.projects?.length || 0) + (prompts.layers?.length || 0)
  },

  // Get available models
  getAvailableModels: (state) => {
    return state.availableModels
  }
}
